import { media, style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import {
    DESKTOP_BREAKPOINT,
    TABLET_BREAKPOINT
} from '../constants';
import { ThemeName } from '../types';

export const mobileOnlyStyles = (
    cssProperties: NestedCSSProperties
) => media({
    maxWidth: (TABLET_BREAKPOINT - 1) + 'px'
}, cssProperties);

export const tabletStyles = (
    cssProperties: NestedCSSProperties
) => media({
    minWidth: TABLET_BREAKPOINT + 'px'
}, cssProperties);

export const tabletOnlyStyles = (
    cssProperties: NestedCSSProperties
) => media({
    minWidth: TABLET_BREAKPOINT + 'px',
    maxWidth: (DESKTOP_BREAKPOINT - 1) + 'px'
}, cssProperties);

export const desktopStyles = (
    cssProperties: NestedCSSProperties
) => media({
    minWidth: DESKTOP_BREAKPOINT + 'px'
}, cssProperties);

type StyleOverrideTuple = [
    className: string,
    nestedCSSProperties: NestedCSSProperties
];

type StyleOverrideRule = {
    [selector: string]: NestedCSSProperties
};

export const styleOverride = (
    selfClassNameStyles: NestedCSSProperties | null,
    ...classNameAndStyles: (StyleOverrideTuple | StyleOverrideRule)[]
): string => {
    const resultNestedStyles: NestedCSSProperties = {
        ...selfClassNameStyles
    };

    if (!resultNestedStyles.$nest) {
        resultNestedStyles.$nest = {};
    }

    classNameAndStyles.forEach((tupleOrRule) => {
        if (Array.isArray(tupleOrRule)) {
            resultNestedStyles.$nest!['.' + tupleOrRule[0]] = tupleOrRule[1];
        }
        else {
            Object.keys(tupleOrRule).forEach(selector => {
                resultNestedStyles.$nest![selector] = tupleOrRule[selector];
            });
        }
    });

    return style(resultNestedStyles);
};

export const getThemeClassName = (
    themeName?: ThemeName | null,
    ...blue_green_classNames: (string | undefined)[]
): string | undefined  => {
    switch (themeName) {
        case 'blue':
            return blue_green_classNames[0];

        case 'green':
            return blue_green_classNames[1];
    }
};
